import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IDowntimeReportCreationDetails } from "./DowntimeReportCreationDetailsInterfaces";
import { useStyles } from "./DowntimeReportCreationDetails.styles";

export const DowntimeReportCreationDetails = ({
    timeStop,
    timeStart,
    duration,
    operator,
}: IDowntimeReportCreationDetails) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.dataContainer}>
            <Box className={classes.itemContainer}>
                <Typography className={classes.title} variant={"subtitle2"}>
                    {t("HMI.details.time_stop").toUpperCase()}
                </Typography>
                <Typography className={classes.text} variant="subtitle1">
                    {timeStop}
                </Typography>
            </Box>
            <Box className={classes.itemContainer}>
                <Typography className={classes.title} variant={"subtitle2"}>
                    {t("HMI.details.time_start").toUpperCase()}
                </Typography>
                <Typography className={classes.text} variant="subtitle1">
                    {timeStart}
                </Typography>
            </Box>
            <Box className={classes.itemContainer}>
                <Typography className={classes.title} variant={"subtitle2"}>
                    {t("HMI.details.duration").toUpperCase()}
                </Typography>
                <Typography className={classes.text} variant="subtitle1">
                    {duration}
                </Typography>
            </Box>
            <Box className={classes.itemContainer}>
                <Typography className={classes.title} variant={"subtitle2"}>
                    {t("HMI.details.operator").toUpperCase()}
                </Typography>
                <Typography className={classes.text} variant="subtitle1">
                    {operator}
                </Typography>
            </Box>
        </Box>
    );
};
